import { useEffect, useState, useContext } from 'react';
import { fetchFryingpanMappings } from '../components/TypeDetails/OperationDetails/RESTOperationView/RESTPlaygroundContainer/utils';
import { StoreContext } from '../appContext/StoreProvider';

export const useRestPlaygroundModal = ({
  shouldOpenPlaygroundFromShareableLink,
  artifactId,
  operation,
}) => {
  const { store } = useContext(StoreContext);

  const [loading, setLoading] = useState(false);
  const [fryingpanEndpoints, setFryingpanEndpoints] = useState(undefined);
  const [isRestPlaygroundModalOpen, setIsRestPlaygroundModalOpen] = useState(
    false,
  );

  const onOpenPlaygroundClick = () => {
    if (store.viewer.isInternalViewer() && artifactId) {
      fetchFryingpanMappings({
        artifactId,
        setLoading,
        operation,
        setFryingpanEndpoints,
      });
    }
    setIsRestPlaygroundModalOpen(true);
  };

  useEffect(() => {
    try {
      if (shouldOpenPlaygroundFromShareableLink) {
        onOpenPlaygroundClick();
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  return {
    isRestPlaygroundModalOpen,
    setIsRestPlaygroundModalOpen,
    onOpenPlaygroundClick,
    loading,
    fryingpanEndpoints,
  };
};
